<ng-container *ngIf="courseObservable | async; let course">
  <app-course-detail-nav [course]="course"></app-course-detail-nav>
  <app-page>
    <app-page-header [ngClass]=AppConfig.theme>
      <app-page-title>
        <span>{{ title }}</span>

        <ng-container>
          <app-course-syllabus-button [routerLink]="['syllabus']">
            <button mat-icon-button>
              <mat-icon>info_outline</mat-icon>
            </button>
          </app-course-syllabus-button>
        </ng-container>

        <app-course-members-button [course]="course">
          <button mat-icon-button *appAuthorize="course.owner">
            <mat-icon class="color-gray">people</mat-icon>
          </button>
        </app-course-members-button>

        <app-course-group-mail-button [course]="course">
          <button mat-icon-button *appAuthorize="course.owner">
            <mat-icon class="color-gray">contact_mail</mat-icon>
          </button>
        </app-course-group-mail-button>

        <app-course-edit-button [course]="course" *appAuthorize="course.owner">
          <button mat-icon-button *appAuthorize="course.owner">
            <mat-icon class="color-gray">edit</mat-icon>
          </button>
        </app-course-edit-button>

        <app-course-billing-button [course]="course" *appAuthorize="course.owner"></app-course-billing-button>
      </app-page-title>
      <app-page-subtitle class="ml-1" *ngIf="course.description">{{ course.description }}</app-page-subtitle>
      <app-page-actions>
        <button mat-fab [matMenuTriggerFor]="addMenu" *appAuthorize="course.owner"
                [ngClass]=AppConfig.theme>
          <mat-icon>add</mat-icon>
        </button>
        <app-course-enrollment-status *appAuthorize="'!'+course.owner" [course]="course">
          <ng-container not-enrolled>
            <app-course-enroll-button [course]="course">
              <button mat-fab>
                <mat-icon>person_add</mat-icon>
              </button>
            </app-course-enroll-button>
          </ng-container>
          <ng-container not-approved>
            <button mat-fab disabled>
              <mat-icon>person_add</mat-icon>
            </button>
          </ng-container>
        </app-course-enrollment-status>
      </app-page-actions>
    </app-page-header>
    <app-page-content class="p-4">
      <app-lecture-list *ngIf="lecturesObservable" [lectures]="lecturesObservable | async" [course]="course"></app-lecture-list>
    </app-page-content>
  </app-page>
  <mat-menu #addMenu="matMenu">
    <app-lecture-add-button-menu [course]="course"></app-lecture-add-button-menu>
  </mat-menu>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-detail/course-detail.component.html